export default __webpack_public_path__ + "static/exp4-90904de981fa87579193a2a469b606cb.png";